<template minapp='mpx' xlang='wxml'>
  <view class="es-field">
    <view class="es-field__inner">
      <textarea
      fixed
      wx:if="{{type === 'textarea'}}"
      wx:style="{{ innerTextAreaStyle }}"
      wx:model="{{ innerValue }}"
      wx:class="{{classnames}}"
      class="es-field__body custom-class"
      focus="{{ focus }}"
      cursor="{{ cursor }}"
      auto-focus="{{ autoFocus }}"
      disabled="{{ disabled }}"
      maxlength="{{ maxlength }}"
      placeholder="{{ placeholder }}"
      auto-height="{{ !!autoHeight }}"
      bindblur="onBlur"
      bindfocus="onFocus"
      bindlinechange="onLineChange"
      bind:keypress='onKeyPress'
      bindinput='onInput'
      placeholder-style="{{placeholderStyle}}"
    />
    
    <input
      wx:else
      fixed
      class="es-field__body custom-class"
      wx:model="{{ innerValue }}"
      wx:class="{{classnames}}"
      type="{{ type }}"
      focus="{{ focus }}"
      cursor="{{ cursor }}"
      auto-focus="{{ autoFocus }}"
      disabled="{{ disabled }}"
      maxlength="{{ maxlength }}"
      placeholder="{{ placeholder }}"
      password="{{ password || type === 'password' }}"
      bindblur="onBlur"
      bindfocus="onFocus"
      bindinput='onInput'
      />
    </view>
    <view class="value-number" wx:if="{{type === 'textarea'&& hasCountDown}}">{{valueNumber + '/' + maxlength}}</view>
<!-- 
    <es-icon 
    wx:if="{{showClear}}" 
    style="margin-left: 10px"
    class='es-field__clear'
    custom-class='es-field__clear'
    name='close' 
    size='12' 
    bind:click='onClear'
    /> -->
  </view>

</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { lib, inputProp, textareaProp } from './props'
  createComponent({
    props: {
      ...lib,
      ...inputProp,
      ...textareaProp
    },

    data: {
      innerValue: '',
      focused: false,
      showClear: false,
      textareaHeight: 24,
      height: 24,
      lines: 1,
      valueNumber:0
    },

    watch: {
      value: {
        immediate: true,
        handler(val) {
          this.innerValue = val
        }
      }
    },

    computed: {
      innerTextAreaStyle() {
        const { autoHeight, height, row = 1, textareaHeight } = this
        return {
          height: height + 'px',
          minHeight: row * textareaHeight + 'px',
          ...this.textAreaStyle
        }
      },

      classnames() {
        return {
          'es-field--border': this.border,
        }
      }
    },

    methods: {
      onFocus(event) {
        this.focused = true
        this.setShowClear()
        this.$trigger('focus', event.detail)
      },

      onBlur(event) {
        this.focused = false
        this.setShowClear()
        this.$trigger('blur', event.detail)
      },

      onInput(event) {
        this.emitChange(event.detail.value)
      },

      setShowClear() {
        const { clearable, focused, innerValue } = this
        this.showClear = !!clearable && !!focused && !!innerValue
      },

      onLineChange(event) {
        const { height, heightRpx, lineCount } = event.detail
        this.$nextTick(() => {
          this.height = this.textareaHeight * lineCount
        })
      },

      // 兼容h5
      onKeyPress(event) {
        const keyCode = event.keyCode
        if (keyCode === 13) {
          this.$nextTick(() => {
            this.lines = this.lines + 1
            this.height = this.lines * this.textareaHeight
          })
        }
      },

      emitChange(value = '') {
        const detail = { value }
        this.innerValue = value
        this.valueNumber = value.length
        this.$nextTick(() => {
          this.$trigger('input', detail)
        })
      },

      onClear() {
        this.emitChange()
        this.setShowClear()
        this.$trigger('clear', this.innerValue)
        this.$nextTick(() => {
          this.height = this.textareaHeight
        })
      }
    }
  })
</script>

<style lang='stylus'>
  @import '../common/style/bem'

  +b('field')
    display flex
    align-items center
    +e('inner')
      flex 1
    +e('body')
      box-sizing border-box
      width 100%
      height 24px
      resize none
      background-color transparent
      text-align left
      line-height 24px
      -webkit-appearance none //是为了去除内阴影样式，但是缺点是不可输入；
      -webkit-user-select auto// 解决输入问题
    +e('clear')
      display inline-block
      width 20px
      height 20px
      line-height 20px
      font-size 12px
      background #eee
      overflow hidden
      text-align center
      border-radius 100%
    +m('border')
      border 1px solid #333
  .es-field
    position relative
  .value-number
    position absolute
    right 10px
    bottom 5px  
    font-size 13px
    color #999999  
</style>

<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '../icon/index'
    }
  }
</script>

